module.exports = __webpack_public_path__ + "img/filter_4.40523c15.svg";